export function replaceMenuSuccess(menu) {
  return {
    type: "REPLACE_MENU_SUCCESS",
    store: menu,
  };
}

export function loadMenu() {
  return {
    type: "LOAD_MENU",
  };
}

export function addProductSync(product) {
  return {
    type: "ADD_PRODUCT_SYNC",
    product,
  };
}

export function cloneProduct(productId) {
  return {
    type: "CLONE_PRODUCT",
    productId,
  };
}

export function cloneProductSync(product) {
  return {
    type: "CLONE_PRODUCT_SYNC",
    product,
  };
}

export function removeProduct(productId, categoryId) {
  return {
    type: "REMOVE_PRODUCT",
    productId,
    categoryId,
  };
}

export function removeProductSync(productId) {
  return {
    type: "REMOVE_PRODUCT_SYNC",
    productId,
  };
}

export function removeCategory(id) {
  return {
    type: "REMOVE_CATEGORY",
    id: id,
  };
}

export function saveProduct(productId, productData) {
  return {
    type: "SAVE_PRODUCT",
    productId,
    productData,
  };
}

export function saveProductSync(productData) {
  return {
    type: "SAVE_PRODUCT_SYNC",
    productData,
  };
}

export function changeVisibilityOfProduct(id, visibility) {
  return {
    type: "CHANGE_VISIBILITY_PRODUCT",
    id,
    visibility,
  };
}

export function changeVisibilityOfProductSync(id, visibility) {
  return {
    type: "CHANGE_VISIBILITY_PRODUCT_SYNC",
    id,
    visibility,
  };
}

export function renameCategory(id, categoryName) {
  return {
    type: "RENAME_CATEGORY",
    id,
    categoryName,
  };
}

export function changeVisibilityOfCategory(id, visibility) {
  return {
    type: "CHANGE_VISIBILITY_CATEGORY",
    id,
    visibility,
  };
}

export function addCategory(categoryName) {
  return {
    type: "ADD_CATEGORY",
    categoryName,
  };
}

export function saveProducts(products) {
  return {
    type: "SAVE_PRODUCTS",
    products,
  };
}

export function saveCategories(categories) {
  return {
    type: "SAVE_CATEGORIES",
    categories,
  };
}

export function setCategories(categories) {
  return {
    type: "SET_CATEGORIES",
    categories,
  };
}
